import IndexedSearchForm from './indexed-search-form';

export default IndexedSearchForm;
